import React from "react";
import { styled } from '@mui/material/styles';
import PropTypes from "prop-types";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TableFooter,
  TablePagination
} from "@mui/material";
import RequestRow from "./RequestRow";

const PREFIX = 'RequestsTable';

const classes = {
  table: `${PREFIX}-table`
};

const StyledTableContainer = styled(TableContainer)(() => ({
  [`& .${classes.table}`]: { width: "100%" }
}));

function RequestsTable({
  requests,
  noLinks = false,
  withPortfolioManagement = false,
  canDelete = false,
  showUnderwriter = false,
  paginationProps = null
}) {

  return (
    <StyledTableContainer component={Paper}>
      <Table className={classes.table} size="small" data-testid="leads-table">
        <TableHead>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>Salesperson</TableCell>
            {showUnderwriter && <TableCell>Underwriter</TableCell>}
            <TableCell>Address</TableCell>
            <TableCell>Asking Price</TableCell>
            <TableCell>Property Name</TableCell>
            <TableCell>Year Built</TableCell>
            <TableCell>Acres</TableCell>
            <TableCell>Units</TableCell>
            <TableCell>Submarket</TableCell>
            <TableCell>Asset Class</TableCell>
            <TableCell>Asset Type</TableCell>
            <TableCell>Priority Status</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {requests.map(request => (
            <RequestRow
              key={JSON.stringify(request)}
              request={request}
              noLinks={noLinks}
              withPortfolioManagement={withPortfolioManagement}
              canDelete={canDelete}
              showUnderwriter={showUnderwriter}
            />
          ))}
        </TableBody>
        {paginationProps && (
          <TableFooter>
            <TablePagination {...paginationProps} />
          </TableFooter>
        )}
      </Table>
    </StyledTableContainer>
  );
}

RequestsTable.propTypes = {
  requests: PropTypes.arrayOf(PropTypes.object),
  noLinks: PropTypes.bool,
  withPortfolioManagement: PropTypes.bool
};

export default RequestsTable;
